"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gateway response from a get operations request.
 */
var GetOperationsResponse = /** @class */ (function () {
    /**
     * Create a new GetOperationsResponse instance
     *
     * @param type response type
     * @param operations the operations
     */
    function GetOperationsResponse(type, operations) {
        this.type = type;
        this.operations = operations;
    }
    return GetOperationsResponse;
}());
exports.GetOperationsResponse = GetOperationsResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/operations/get-operations-response.js
// module id = 1955
// module chunks = 1